import axios from "axios";
export const GET_ALL_VIDEOGAMES = "GET_ALL_VIDEOGAMES";
export const GET_NAMES = "GET_NAMES";
export const GET_VIDEOGAME = "GET_VIDEOGAME";
export const GET_BY_GENRES = "GET_BY_GENRES";
export const CREATE_VIDEOGAME = "CREATE_VIDEOGAME";
export const ORDER_BY = "ORDER_BY";
export const FILTER_BY_GENRES = "FILTER_BY_GENRES";
export const GET_PLATFORMS = "GET_PLATFORMS";
export const GET_PAGEONE = "GET_PAGEONE";
export const SEARCH_NAME = "SEARCH_NAME";
require("dotenv").config();
const { REACT_APP_BACKEND_HOST } = process.env;

export const getPageOne = (set) => async (dispatch) => {
  const res = await axios.get(`${REACT_APP_BACKEND_HOST}/videogames/pageone`);
  const data = res.data;
  return dispatch(
    {
      type: GET_PAGEONE,
      payload: data,
    },
    set(false)
  );
};

export const getAllVideogames = () => async (dispatch) => {
  const res = await axios.get(`${REACT_APP_BACKEND_HOST}/videogames`);
  const data = res.data;
  return dispatch({
    type: GET_ALL_VIDEOGAMES,
    payload: data,
  });
};

export const getNames = (name) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `${REACT_APP_BACKEND_HOST}/videogames?name=${name}`
      );
      return dispatch({
        type: GET_NAMES,
        payload: data,
      });
    } catch (err) {
      console.error(err);
      return dispatch({
        type: GET_NAMES,
        payload: [],
      });
    }
  };
};

export const getVideogame = (id) => async (dispatch) => {
  return axios
    .get(`${REACT_APP_BACKEND_HOST}/videogame/${id}`)
    .then((res) => res.data)
    .then((data) =>
      dispatch({
        type: GET_VIDEOGAME,
        payload: data,
      })
    );
};

export const getByGenres = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`${REACT_APP_BACKEND_HOST}/genres`);
      return dispatch({
        type: GET_BY_GENRES,
        payload: data,
      });
    } catch (err) {
      console.log(err);
    }
  };
};

export const filterByGenres = (payload) => {
  return {
    type: FILTER_BY_GENRES,
    payload,
  };
};

export const createVideogame = (videogame) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(
        `${REACT_APP_BACKEND_HOST}/videogames`,
        videogame
      );
      return dispatch({
        type: CREATE_VIDEOGAME,
        payload: data,
      });
    } catch (err) {
      console.error(err);
    }
  };
};

export const orderBy = (payload) => {
  return {
    type: "ORDER_BY",
    payload,
  };
};

export const searchName = (payload) => {
  return {
    type: SEARCH_NAME,
    payload,
  };
};

export const getPlatforms = () => {
  return async (dispatch) => {
    const url = await axios.get(
      `${REACT_APP_BACKEND_HOST}/videogames/platforms`
    );
    //console.log(url)
    return dispatch({
      type: GET_PLATFORMS,
      payload: url.data,
    });
  };
};
